import { ChecPopconfirm } from 'components/chec'
import { Alert, Button, Col, Header, Loading, Row } from 'components/patterns'
import PropTypes from 'prop-types'
import {
  adjust,
  always,
  assoc,
  both,
  clone,
  compose,
  cond,
  identity,
  isEmpty,
  isNil,
  length,
  map,
  mergeLeft,
  not,
  prop,
  propEq,
  reject,
  T,
  uniq,
} from 'ramda'
import React, { Component } from 'react'
import {
  NOTIFICATION_ERROR,
  LOGIC_SETS,
  TIMERS,
  CAN_INPUTS,
  SWITCH_INDICATORS,
  restrictedModules,
} from 'utils/constants'
import { filterOutUsedSwitches, getIOSwitchList } from 'utils/feature'
import { isEmptyOrNil } from 'utils/functional'
import strings from 'utils/strings'
import { isArray, isFalse, isNull } from 'utils/types'
import { validateDynamicContent } from 'services/features'
import { FAST_FEATURES_EXCLUDED_SUBTYPES } from 'utils/constants/vehicle-constants'
import { forceUnique } from 'utils/common-ramda-utilities'
import ActionButtons from './ActionButtons'
import KeepOrRemoveSwitches from './Modals/KeepOrRemoveSwitches'
import AddRemoveFeatureSearchAndResultsTable from './AddRemoveFeatureSearchAndResultsTable'
import AddRemoveFeaturesTable from './AddRemoveFeaturesTable'
import FeatureCollectionToggle from './FeatureCollectionToggle'
import {
  ArticleStyled,
  FooterStyled,
  StyledHeader,
} from './AddRemoveVehicleFeatures.style'
import CommitView from './CommitView'
import ConflictingSwitches from './ConflictingSwitches'
import ConflictsOverView from './ConflictsOverView'
import ConflictsResolveView from './ConflictsResolveView'
import {
  CONFLICTS_OVER_VIEW,
  CONFLICTS_SWITCHES_WITH_SHARED_SIGNALS_VIEW,
  CONFLICTS_TABLE_VIEWS,
  NO_CONFLICT,
} from './constants'
import FeatureInputModal from './Modals/FeatureInputModal'
import FeatureInputSwitchSelectionModal from './Modals/FeatureInputSwitchSelectionModal'
// import SwitchSelectionNeededModal from './Modals/SwitchSelectionNeededModal'
// import SwitchSelectionModal from './Modals/SwitchSelectionModal'
import {
  getConflictingFeaturesThatWillBeRemoved,
  getOutstandingSwitchMappings,
  getFeaturesForMappingRows,
  getAllSignalIds,
  getIOSwitchesList,
  getMaxNotificationString,
  getSingleOptionIoSwitches,
  getSwitchesAlreadyOnVehicle,
  getUnresolvedConflictsCounts,
  getVehicleSwitchPanelNumbers,
  enrichIoSwitchesWithVehicleData,
  getSignalIdsOnVehicle,
  getPreSelectedSwitchesForExistingSignals,
  notProp,
  postUpdates,
  resolveFeatureUri,
  resolvePreviousUri,
  validateAndGetConflicts,
  getKeepOrRemoveSwitchTableData,
  getUpdatedKeepOrRemoveSwitches,
  urisFilteredBy,
  getRejectedFeatureKeys,
  pruneRejectedFeaturesFromConflicts,
} from './utils'
import DynamicFeatureValidationModal from './DynamicFeatureValidationModal'
import FeatureVersionUpdateModal, {
  getUpdatedFeature,
} from '../FeatureVersionUpdateModal'
import { getSwitchDiffOnUpdate } from './utils/feature-updates'

class AddRemoveVehicleFeatures extends Component {
  constructor(props) {
    super(props)
    const { features } = props

    this.state = this.getInitialState(features)
  }

  getInitialState = (features) => ({
    onGoingSet: clone(features),
    proposedSet: clone(features),
    selectedSearchFeatures: [],
    warning: false,
    canCommit: false,
    commitMessage: '',
    showCommitView: false,
    currentConflictingFeatures: null,
    currentConflictingSwitches: null,
    // Pristine API conflict state — set once, never overwritten by confirmations.
    originalConflictingFeatures: null,
    replacementConflictingFeatures: null,
    conflictDataColumns: [],
    dirty: false,
    isUpdating: false,
    showFeatureInputModal: false,
    showInputSwitchSelectionModal: false,
    // showSwitchSelectionNeededModal: false,
    // showSwitchSelectionModal: false,
    // featuresWithUnconnectedSignals: [],
    inputFeatureState: null,
    addedSwitches: {},
    addedIOSwitchesFromUpdate: {},
    removedIOSwitchesFromUpdate: {},
    isSwitchesMarkedForAddition: false,
    preSelectedSwitches: {},
    currentConflictView: NO_CONFLICT,
    currentConflictModule: null,
    currentConflictPin: null,
    currentConflictSelection: null,
    currentConflictStep: 0,
    dynamicValidationData: [],
    // if there are removed switch, placeholder for which are kept, which are removed
    // used in the POST to removed switches from removed list if use chooses to keep
    keepOrRemoveSwitches: [],
    isKeepOrRemoveSwitchesModalOpen: false,
    showFeatureControlSolenoidAlert: false,
    optionalSolenoidsExceedingLimit: [],
    showFeatureVersionUpdateModal: false,
    featureUpdateSection: null,
  })

  getNewUniqueSolenoids = (features) =>
    uniq(
      features
        .flatMap((item) => item.solenoidIds)
        .filter((x) => !this.props.solenoidsOnVehicle.includes(x))
    )

  componentDidUpdate(_, prevState) {
    // this is here to disable Add Feature btn
    // when a new search has been triggered, it technically
    // clears out any selections, cause, you know, new search.

    const { hasSearchResults, features } = this.props
    const { onGoingSet } = this.state
    const { selectedSearchFeatures } = prevState
    if (!hasSearchResults && length(selectedSearchFeatures) > 0) {
      this.setState({
        selectedSearchFeatures: [],
      })
    }
    if (!isNull(features) && isNull(onGoingSet)) {
      this.setState({
        onGoingSet: forceUnique(clone(features)),
        proposedSet: forceUnique(clone(features)),
      })
    }
  }

  handleSelectedFeature = (selected) => {
    const { selectedSearchFeatures, proposedSet } = this.state
    const found = selectedSearchFeatures.find((i) => i.uri === selected.uri)
    if (found) {
      this.setState({
        selectedSearchFeatures: selectedSearchFeatures.filter(
          (item) => item.uri !== found.uri
        ),
        proposedSet: proposedSet.filter((item) => item.uri !== found.uri),
      })
    } else {
      this.setState({
        selectedSearchFeatures: [...selectedSearchFeatures, selected],
      })
    }
  }

  handleSelectedFeatureRevision = (
    previousFeature,
    revisedFeature,
    invalid
  ) => {
    const { selectedSearchFeatures } = this.state
    const hasSameFeatureIdentity = (feature) =>
      feature.partNumber && previousFeature.partNumber
        ? feature.partNumber === previousFeature.partNumber
        : feature.uri === previousFeature.uri
    const selectedIndex = selectedSearchFeatures.findIndex(
      hasSameFeatureIdentity
    )

    if (selectedIndex === -1) return

    this.setState({
      selectedSearchFeatures: invalid
        ? selectedSearchFeatures.filter((item) => !hasSameFeatureIdentity(item))
        : selectedSearchFeatures.map((item, index) =>
            index === selectedIndex ? revisedFeature : item
          ),
    })
  }

  handleSelectAllFeatures = (features, shouldSelect) => {
    if (shouldSelect) {
      this.setState({
        selectedSearchFeatures: [...features],
      })
    } else {
      this.setState({
        selectedSearchFeatures: [],
      })
    }
  }

  handleAddFeature = async (item = null, isUpdatingToLatestSnapshot) => {
    const { serialNumber } = this.props
    const {
      selectedSearchFeatures,
      proposedSet,
      addedSwitches,
      addedIOSwitchesFromUpdate,
      removedIOSwitchesFromUpdate,
    } = this.state

    const newSolenoids = this.getNewUniqueSolenoids(selectedSearchFeatures)

    const newSolenoidsWithFeatureDetails = selectedSearchFeatures.reduce(
      (prev, curr) => {
        if (curr.solenoidIds) {
          const alreadyAdded = new Set(prev.map((p) => p.solenoidId))
          return [
            ...prev,
            ...uniq(curr.solenoidIds)
              .filter((x) => newSolenoids.includes(x) && !alreadyAdded.has(x))
              .map((y, idx) => ({
                solenoidId: y,
                idx: idx + 1,
                moduleName: curr.moduleName,
                partNumber: curr.partNumber,
                featureId: curr.id,
                description: curr.description,
              })),
          ]
        }
        return prev
      },
      []
    )

    const markedForUpdate = (updateItem) =>
      isFalse(updateItem.latestOnVehicle) && not(updateItem.isMarkedForDeletion)

    const findFeatureToAdd = cond([
      [
        isNil,
        always(
          selectedSearchFeatures.map((f) => ({
            ...f,
            isMarkedForAddition: true,
            latestOnVehicle: true,
          }))
        ),
      ],
      [
        markedForUpdate,
        always(
          new Array(
            mergeLeft({ isMarkedForAddition: true, latestOnVehicle: true })
          )
        ),
      ],
      [T, (i) => (isArray(i) ? i : new Array(i))],
    ])

    const markedNewAddition = findFeatureToAdd(item)

    const markedForUpdateSet = (set) => {
      const markedUpdateIndex = set.findIndex(propEq('id', item.id))
      const mergeItem = (mergingItem) => ({
        ...mergingItem.latestSnapshot.object.feature,
        uri: mergingItem.uri,
        revision:
          mergingItem.latestSnapshot?.object?.feature?.revision ||
          mergingItem.revision,
        isMarkedForAddition: true,
        isMarkedForUpdate: true,
        latestOnVehicle: true,
        previousSnapshot: mergingItem,
      })

      return adjust(markedUpdateIndex, mergeItem, set)
    }

    const findUpdatedSet = cond([
      [() => isNil(item), always([...markedNewAddition, ...proposedSet])],
      [() => markedForUpdate(item), markedForUpdateSet],
      [T, identity],
    ])

    const updatedSet = findUpdatedSet(proposedSet)

    this.setState({ requestingValidation: true })

    // in the cases where something that was on but now removed is being added back
    const actuallyHasUpdates = updatedSet.some(
      (f) =>
        f.isMarkedForAddition || f.isMarkedForDeletion || f.isMarkedForUpdate
    )
    // if no actual updates, bail early, API can't handle an empty check, or check if feature is already on vehicle
    if (!actuallyHasUpdates) {
      this.setState({
        onGoingSet: updatedSet,
        proposedSet: updatedSet,
        requestingValidation: false,
      })
      return
    }

    const { currentConflictingFeatures, err } = await validateAndGetConflicts(
      this.props.dispatch,
      serialNumber,
      updatedSet
    )

    if (err) {
      this.setState({ requestingValidation: false })
      this.props.apiErrorHandler()
      return
    }

    const noConflicts = isEmptyOrNil(currentConflictingFeatures)

    // Bug #505985: When every conflict pin is auto-resolved (single option),
    // there's nothing for the user to decide. Treat as "no conflicts" so the
    // flow skips the unnecessary conflict resolution screen.
    const allAutoResolved =
      !noConflicts &&
      getUnresolvedConflictsCounts(currentConflictingFeatures).every(
        (c) => c === 0
      )
    const effectivelyNoConflicts = noConflicts || allAutoResolved

    if (isUpdatingToLatestSnapshot) {
      const { addedSwitches, removedSwitches } = getSwitchDiffOnUpdate(item)

      this.setState({
        addedIOSwitchesFromUpdate: {
          ...addedIOSwitchesFromUpdate,
          ...addedSwitches,
        },
        removedIOSwitchesFromUpdate: {
          ...removedIOSwitchesFromUpdate,
          ...removedSwitches,
        },
      })
    }

    // Enrich newly-added features' ioSwitches with isSwitchOnVehicle
    // by cross-referencing against the vehicle's existing switches
    const vehiclePanelNumbers = getVehicleSwitchPanelNumbers(proposedSet)
    let enrichedNewAddition = enrichIoSwitchesWithVehicleData(
      markedNewAddition,
      vehiclePanelNumbers
    )

    // Bug #504270: Signals already present on the vehicle don't need switch
    // selection — the existing assignment carries forward automatically.
    const existingSignalIds = getSignalIdsOnVehicle(proposedSet)

    // Bug #512954/513636: When the vehicle has a physical switch that isn't
    // used by any existing feature, getVehicleSwitchPanelNumbers cannot detect
    // it (no existing feature has isSwitchOnVehicle: true for that panel).
    // For any ioSwitch that the local enrichment couldn't resolve (no switch
    // marked on-vehicle, signal not already on vehicle), query the server to
    // confirm which panels are physically installed and apply a second
    // enrichment pass so the review step skips the selection prompt.
    const unresolvedCandidatePanels = []
    enrichedNewAddition.forEach((feature) => {
      ;(feature.ioSwitches || []).forEach((ioSwitch) => {
        const switches = ioSwitch.switches || []
        if (switches.length <= 1) return
        if (existingSignalIds.has(ioSwitch.id)) return
        const hasApiData = switches.some((sw) => sw.isSwitchOnVehicle)
        if (hasApiData) return
        switches.forEach((sw) => {
          if (sw.panelNumber) unresolvedCandidatePanels.push(sw.panelNumber)
        })
      })
    })
    if (unresolvedCandidatePanels.length > 0) {
      try {
        const serverResult = await getSwitchesAlreadyOnVehicle(
          this.props.dispatch,
          serialNumber,
          [...new Set(unresolvedCandidatePanels)]
        )
        if (serverResult.ok && serverResult.panels.length > 0) {
          enrichedNewAddition = enrichIoSwitchesWithVehicleData(
            enrichedNewAddition,
            new Set(serverResult.panels)
          )
        }
      } catch (_err) {
        // Network/server error: fall through with locally-enriched data.
        // The user will see the switch selection prompt (same as pre-fix
        // behaviour) rather than a silent broken state.
      }
    }

    // Keep requestingValidation true until both the conflict check and the
    // physical-switch pre-check have finished. Clearing it earlier (after only
    // the conflict check) leaves a window where the UI is interactive while the
    // switch-mapping decision is still pending, allowing a second Add Feature
    // click to race against the in-flight request.
    this.setState({ requestingValidation: false })

    const existingSignalSwitches = getPreSelectedSwitchesForExistingSignals(
      enrichedNewAddition,
      existingSignalIds
    )

    const noSwitchesToAssign = enrichedNewAddition.reduce((acc, curr) => {
      if (acc === false) return acc

      const { ioSwitches } = curr
      if (ioSwitches) {
        return !ioSwitches.find((ioSwitch) => {
          const switches = prop('switches', ioSwitch)
          if (length(switches) <= 1) return false
          // Skip signals already on the vehicle
          if (existingSignalIds.has(ioSwitch.id)) return false
          const onVehicleCount = switches.filter(
            (sw) => sw.isSwitchOnVehicle
          ).length
          return onVehicleCount !== 1
        })
      }

      return acc
    }, true)

    const dirty = updatedSet.some(
      (f) =>
        f.isMarkedForAddition || f.isMarkedForDeletion || f.isMarkedForUpdate
    )

    if (effectivelyNoConflicts && noSwitchesToAssign) {
      const singleOptionIoSwitches =
        getSingleOptionIoSwitches(enrichedNewAddition)

      this.setState(
        {
          onGoingSet: forceUnique(clone(updatedSet)),
          proposedSet: forceUnique(updatedSet),
          preSelectedSwitches: {
            ...singleOptionIoSwitches,
            ...existingSignalSwitches,
          },
          dirty,
        },
        this.props.resetSearch
      )
    } else {
      const singleOptionIoSwitches =
        getSingleOptionIoSwitches(enrichedNewAddition)

      const nextPreSelectedSwitches = {
        ...singleOptionIoSwitches,
        ...existingSignalSwitches,
      }

      if (!noSwitchesToAssign) {
        // Derived from the whole staged set, not just this addition. A previous
        // add whose mapping modal the user dismissed is still outstanding, and
        // listing only the current addition would hide it from the modal — the
        // commit gate would then block on work the modal never offered.
        const ioSwitchesRequiringSwitchMapping = getOutstandingSwitchMappings(
          updatedSet,
          nextPreSelectedSwitches,
          addedSwitches
        )

        this.setState({
          ioSwitches: ioSwitchesRequiringSwitchMapping,
          preSelectedSwitches: nextPreSelectedSwitches,
          dirty,
        })
      } else {
        // This addition needs no mapping, but an earlier one may still.
        this.setState({
          ioSwitches: getOutstandingSwitchMappings(
            updatedSet,
            nextPreSelectedSwitches,
            addedSwitches
          ),
          preSelectedSwitches: nextPreSelectedSwitches,
          dirty,
        })
      }

      // Bug #505985: reaching this branch does NOT imply there are conflicts —
      // it is also reached when there is nothing to resolve but switches still
      // need mapping. Routing that case through CONFLICTS_OVER_VIEW showed the
      // Conflict Resolution page with zero conflicts in every area, forcing the
      // user through "Review Features" for no decisions. Switch mapping is a
      // modal (FeatureInputModal), not a conflict view, so open it directly and
      // leave the view at NO_CONFLICT — the feature list stays on screen behind
      // it and "Commit to Vehicle" enables once mapping completes.
      const onlySwitchMappingRemains =
        effectivelyNoConflicts && !noSwitchesToAssign

      this.setState({
        proposedSet: updatedSet,
        // Promote the staged additions into the visible working set, but only on
        // the direct-modal route. AddRemoveFeaturesTable renders onGoingSet, and
        // the CONFLICTS_OVER_VIEW route deliberately defers this to
        // handleReviewFeatures — skipping the overview means nothing else ever does
        // it, so cancelling the mapping modal left the staged row invisible and the
        // user unable to see what was blocking commit. Reopening the mapping itself
        // is handled by the footer action (handleReopenSwitchMapping); the table has
        // no switch cell to click.
        ...(onlySwitchMappingRemains && {
          onGoingSet: forceUnique(clone(updatedSet)),
        }),
        // Store null (not undefined) so render's isNull check works correctly
        currentConflictingFeatures: currentConflictingFeatures || null,
        // Deep-clone so originalConflictingFeatures is a truly isolated copy.
        // If the same reference were stored, the in-place selection mutation in
        // handleConfirmSelection would corrupt the pristine snapshot.
        originalConflictingFeatures: clone(currentConflictingFeatures) || null,
        replacementConflictingFeatures: [markedNewAddition],
        currentConflictView: onlySwitchMappingRemains
          ? NO_CONFLICT
          : CONFLICTS_OVER_VIEW,
        ...(onlySwitchMappingRemains && { showFeatureInputModal: true }),
      })
    }

    if (newSolenoids.length) {
      this.setState(
        this.props.availableSlotsOnVehicle.length >= newSolenoids.length
          ? { showFeatureControlSolenoidAlert: true }
          : {
              optionalSolenoidsExceedingLimit: newSolenoidsWithFeatureDetails,
            }
      )
    }
  }

  // ids can be array or single id
  handleToggleRemoveFeature = (
    ids,
    isAlreadyMarkedForDeletion,
    callback = null
  ) => {
    const { proposedSet, selectedSearchFeatures } = this.state

    // if already marked for deletion, the user is toggling it back
    // need to toggle back to add feature and update state
    if (isAlreadyMarkedForDeletion) {
      const nextProposedSet = proposedSet.map((f) => {
        if (f.id === ids) {
          delete f.isMarkedForDeletion
          return {
            ...f,
          }
        }
        return f
      })

      const dirty = nextProposedSet.some(
        (f) =>
          f.isMarkedForAddition || f.isMarkedForDeletion || f.isMarkedForUpdate
      )

      this.setState(
        {
          onGoingSet: nextProposedSet,
          proposedSet: nextProposedSet,
          dirty,
        },
        () => {
          // run this if any feature isMarkedForAddition
          const hasAnyMarkedForAddtion = this.state.proposedSet.some(
            (f) => f.isMarkedForAddition
          )

          if (hasAnyMarkedForAddtion) this.handleAddFeature()
        }
      )

      return
    }

    // here is where the normal remove feature logic starts
    const removedIds = isArray(ids) ? ids : [ids]

    // handle if ids are from search features, not features on vehicle
    // if feature is from search, we want to just remove from proposed set
    // for this to work, users cannot select a search feature already on a vehicle
    // which is a rule for disabling the select checkbox
    const featureIdsFromSearch = selectedSearchFeatures.reduce((acc, curr) => {
      if (removedIds.includes(curr.id)) return [...acc, curr.id]
      return acc
    }, [])

    // if we have features from search
    // remove from proposedSet via mutation
    if (length(featureIdsFromSearch)) {
      featureIdsFromSearch.forEach((id) => {
        const foundIndex = proposedSet.findIndex((f) => f.id === id)
        if (foundIndex > -1) {
          proposedSet.splice(foundIndex, 1)
        }
      })
    }

    // handle ids are from features on vehicle
    const updateSet = map((feature) => {
      const isFeatureInRemovedList = removedIds.includes(feature.id)

      if (isFeatureInRemovedList) {
        if (feature.isMarkedForUpdate) {
          return {
            ...feature.previousSnapshot,
            isMarkedForDeletion: true,
          }
        }
        return {
          ...feature,
          isMarkedForDeletion: true,
        }
      }

      return feature
    })

    const shouldRemoveFromList = (f) =>
      f.isMarkedForDeletion && f.isMarkedForAddition && !f.isMarkedForUpdate

    const updatedSet = compose(updateSet)(proposedSet)

    // clean up switches
    const { preSelectedSwitches = {}, addedSwitches = {} } = this.state

    // Collect signal IDs belonging to removed features so we can prune
    // stale switch mappings. Look up by feature ioSwitches signal ids.
    const signalIdsOfRemovedFeatures = new Set(
      updatedSet
        .filter((f) => f.isMarkedForDeletion && f.ioSwitches)
        .flatMap((f) => f.ioSwitches.map((io) => io.id))
    )

    const getStaleSignalIds = (mapping) =>
      Object.keys(mapping).filter((signalId) =>
        signalIdsOfRemovedFeatures.has(signalId)
      )

    const signalIdsToRemove = [
      ...getStaleSignalIds(preSelectedSwitches),
      ...getStaleSignalIds(addedSwitches),
    ]

    signalIdsToRemove.forEach((signal) => {
      delete preSelectedSwitches[signal]
      delete addedSwitches[signal]
    })

    const nextSet = compose(reject(shouldRemoveFromList))(updatedSet)

    // Drop the mapping rows belonging to the features being removed, so the modal
    // cannot offer a switch for a feature that is no longer staged. The commit
    // gate no longer depends on this — it recomputes from the staged set — but
    // `ioSwitches` is still what FeatureInputModal renders.
    //
    // Keyed on `featureId`, which getIoSwitchesForMapping stamps onto every entry.
    // That is exact, and unlike the signal-id pruning above it also covers a
    // staged search feature: those are spliced out of proposedSet before
    // updatedSet is built, so they never carry isMarkedForDeletion.
    const { ioSwitches = [] } = this.state
    const nextIoSwitches = ioSwitches.filter(
      (io) => !removedIds.includes(io.featureId)
    )

    // no validation necessary
    if (!callback) {
      this.setState({
        onGoingSet: forceUnique(clone(updatedSet)),
        preSelectedSwitches,
        addedSwitches,
        ioSwitches: nextIoSwitches,
        dirty: true,
      })
    }

    this.setState(
      {
        onGoingSet: nextSet,
        proposedSet: nextSet,
        canCommit: true,
        preSelectedSwitches,
        addedSwitches,
        ioSwitches: nextIoSwitches,
        dirty: true,
      },
      callback
    )

    const stillHasChanges = nextSet.some(
      (f) =>
        f.isMarkedForAddition || f.isMarkedForDeletion || f.isMarkedForUpdate
    )

    // if there are no changes in nextSet, reset
    if (!stillHasChanges) {
      this.setState({
        dirty: false,
        showCommitView: false,
      })
    }
  }

  handleFeaturesUpdating = (isUpdating) => {
    this.setState({
      isUpdating,
    })
  }

  handleDynamicValidation = async (onGoingSet) => {
    this.setState({
      isValidatingDynamicFeatures: true,
    })
    try {
      const addedFeatures = onGoingSet
        .filter((f) => f.isMarkedForAddition)
        .map(resolveFeatureUri)
        .filter(Boolean)
      const removedFeatures = uniq([
        ...urisFilteredBy('isMarkedForDeletion')(onGoingSet),
        ...onGoingSet
          .filter((f) => f.isMarkedForUpdate)
          .map(resolvePreviousUri)
          .filter(Boolean),
      ])

      const hasMarkedChanges = onGoingSet.some(
        (f) =>
          f.isMarkedForAddition || f.isMarkedForDeletion || f.isMarkedForUpdate
      )
      if (!hasMarkedChanges) {
        this.commitUpdates()
        return
      }

      const response = await validateDynamicContent({
        payload: {
          addedFeatures,
          removedFeatures,
        },
        serialNumber: this.props.serialNumber,
      })
      if (response.data.length === 0) {
        this.commitUpdates()
      } else {
        this.setState({
          dynamicValidationData: response.data,
        })
      }
    } catch (err) {
      console.error(err)
    } finally {
      this.setState({
        isValidatingDynamicFeatures: false,
      })
    }
  }

  handleCommitUpdates = async () => {
    const {
      onGoingSet,
      isKeepOrRemoveSwitchesModalOpen,
      addedSwitches,
      showCommitView,
    } = this.state

    const [keepRemoveSwitchTableData, removedIOsWithSwitchesList] =
      getKeepOrRemoveSwitchTableData(onGoingSet, addedSwitches)

    if (
      !showCommitView &&
      !isKeepOrRemoveSwitchesModalOpen &&
      keepRemoveSwitchTableData.length
    ) {
      this.setState({
        isKeepOrRemoveSwitchesModalOpen: true,
        keepOrRemoveSwitches: removedIOsWithSwitchesList,
      })
    } else {
      this.handleDynamicValidation(onGoingSet)
    }
  }

  commitUpdates = async () => {
    const {
      showCommitView,
      onGoingSet,
      commitMessage,
      addedSwitches,
      addedIOSwitchesFromUpdate,
      removedIOSwitchesFromUpdate,
      preSelectedSwitches,
      keepOrRemoveSwitches,
    } = this.state

    const removedFeatures = onGoingSet.filter(prop('isMarkedForDeletion'))
    const removedIOsWithSwitchesList = getIOSwitchesList(removedFeatures)

    const handleRemovedSwitches = () => {
      if (!isEmpty(removedFeatures)) {
        const removed = removedIOsWithSwitchesList.reduce((acc, io) => {
          if (!isNil(io.switches) && !isEmpty(io.switches)) {
            const removedSwitch = io.switches.find((x) => x.isSwitchOnVehicle)
            if (!isNil(removedSwitch)) {
              acc.push(removedSwitch.panelNumber)
            }
          }
          return acc
        }, [])
        // panelNumbers from switches from removed features
        const panelNumbersRemovedWithOutUsed = uniq(
          filterOutUsedSwitches(removed, onGoingSet)
        )
        // panelNumbers from user confirmed switches to remove
        const panelNumbersMarkedForDeletion = keepOrRemoveSwitches
          .reduce((acc, curr) => {
            const { switches = [] } = curr
            return [...acc, ...switches]
          }, [])
          .flat()
          .filter(prop('isMarkedForDeletion'))
          .map(prop('panelNumber'))

        // only use panelNumbers that are not user confirmed
        const removedAndMarkedForDeletion =
          panelNumbersRemovedWithOutUsed.filter((panelNumber) =>
            panelNumbersMarkedForDeletion.includes(panelNumber)
          )

        return removedAndMarkedForDeletion
      }

      return []
    }

    const removedSwitches = uniq([
      ...handleRemovedSwitches(),
      ...Object.values(removedIOSwitchesFromUpdate),
    ])

    const {
      goToPneumatics,
      createSystemNotification,
      serialNumber,
      vehicleArea,
      featureUpdateCompleteByVehicleArea,
    } = this.props

    if (!showCommitView) {
      this.toggleCommitView()
    } else {
      try {
        this.handleFeaturesUpdating(true)
        // single switches (or preSelectedSwitches) can be added when resolving conflicts
        // seems the best place to get those single switches is here, adjust
        const singleSwitches = getSingleOptionIoSwitches(
          onGoingSet.filter((f) => f.isMarkedForAddition)
        )

        const ioSwitchesToAdd = {
          ...addedSwitches,
          ...addedIOSwitchesFromUpdate,
          ...preSelectedSwitches,
          ...singleSwitches,
        }

        const candidatePanels = Object.values(ioSwitchesToAdd).filter(Boolean)
        const validationResult = await getSwitchesAlreadyOnVehicle(
          this.props.dispatch,
          serialNumber,
          candidatePanels
        )

        if (!validationResult.ok) {
          this.handleFeaturesUpdating(false)
          this.props.dispatch(
            createSystemNotification({
              notificationMessage: strings.switch_validation_failed,
              notificationType: NOTIFICATION_ERROR,
              persistent: true,
              closable: true,
            })
          )
          return
        }

        const excludedPanels = new Set(validationResult.panels)
        const filteredSwitchesToAdd = Object.entries(ioSwitchesToAdd)
          .filter(([, panelNumber]) => !excludedPanels.has(panelNumber))
          .reduce(
            (acc, [signalId, panelNumber]) => ({
              ...acc,
              [signalId]: panelNumber,
            }),
            {}
          )

        const {
          optionalSolenoidsExceedingLimit,
          showFeatureControlSolenoidAlert,
        } = this.state

        const newSolenoids = this.getNewUniqueSolenoids(
          onGoingSet.filter((item) => item.isMarkedForAddition)
        )

        // postUpdates dispatches updateVehicleFeatures (a promiseApiAction).
        // apiCall already dispatches TRUCK_FEATURES_UPDATED on success, which
        // triggers the features.js saga side effects (getTruckModules, CTP fetch).
        // Do NOT call truckFeaturesUpdated() manually here — that would dispatch
        // TRUCK_FEATURES_UPDATED a second time, causing redundant module/CTP fetches.
        await postUpdates(
          this.props.dispatch,
          serialNumber,
          onGoingSet,
          commitMessage,
          filteredSwitchesToAdd,
          removedSwitches,
          showFeatureControlSolenoidAlert &&
            !optionalSolenoidsExceedingLimit?.length
            ? newSolenoids
            : []
        )

        this.handleFeaturesUpdating(false)

        this.closeAndReset()
        featureUpdateCompleteByVehicleArea(vehicleArea, serialNumber, {
          optionalSolenoidsExceedingLimit,
          goToPneumatics,
        })
      } catch (err) {
        // The handler chain (defaultErrorHandler) already shows the blocking
        // ErrorModal for POST mutation failures — do not dispatch an additional
        // system notification here, as that would give the user both a modal and
        // a persistent banner for the same error.
        // We still call closeAndReset() to collapse the commit view so the UI
        // returns to a clean state after the modal is dismissed.
        this.closeAndReset()
      }
    }
  }

  toggleCommitView = () => {
    const { showCommitView } = this.state

    this.setState({
      showCommitView: !showCommitView,
    })
  }

  handleCommitMessageChange = (e) => {
    this.setState({
      commitMessage: e.target.value,
    })
  }

  handleContinueAndAddSwitch = () => {
    const { proposedSet } = this.state

    this.setState(
      {
        onGoingSet: forceUnique(clone(proposedSet)),
        dirty: true,
      },
      this.props.resetSearch
    )
  }

  handleSelectSwitch = () => {
    this.setState({
      showFeatureInputModal: false,
      showInputSwitchSelectionModal: true,
    })
  }

  handleSelectInputSwitch = (selectedSwitches) => {
    const { preSelectedSwitches, addedSwitches, ioSwitches } = this.state

    // Accept an assignment for any signal currently listed as outstanding, not
    // just the latest add's. The list can span batches — a feature whose mapping
    // modal was dismissed earlier is still on it — and filtering against
    // selectedSearchFeatures would silently drop that feature's selection.
    const outstandingSignalIds = new Set((ioSwitches || []).map((io) => io.id))
    const switches = Object.entries(selectedSwitches).reduce(
      (acc, [key, value]) => {
        if (outstandingSignalIds.has(key)) {
          return {
            ...acc,
            [key]: value,
          }
        }
        return acc
      },
      {}
    )

    this.setState({
      dirty: true, // just by virtue of this handler being called, we know things have changed
      showInputSwitchSelectionModal: false,
      // Merge onto the existing assignments rather than replacing them: a mapping
      // completed for an earlier add must survive a later one.
      addedSwitches: { ...addedSwitches, ...switches, ...preSelectedSwitches },
    })
  }

  // // PBI 147363 - Handlers for SwitchSelectionNeededModal
  // handleCloseSwitchSelectionNeededModal = () => {
  //   this.setState({
  //     showSwitchSelectionNeededModal: false,
  //     featuresWithUnconnectedSignals: [],
  //   })
  // }

  // handleSelectSwitchesFromNeededModal = () => {
  //   // PBI 147363 - Documentation 4: Show new SwitchSelectionModal
  //   this.setState({
  //     showSwitchSelectionNeededModal: false,
  //     showSwitchSelectionModal: true,
  //   })
  // }

  // // PBI 147363 - Handler for new SwitchSelectionModal confirm
  // handleSwitchSelectionModalConfirm = (selectedSwitches) => {
  //   this.setState({
  //     showSwitchSelectionModal: false,
  //     addedSwitches: selectedSwitches,
  //     allSwitchesMapped: true,
  //   })
  // }

  // // PBI 147363 - Handler for new SwitchSelectionModal cancel
  // handleSwitchSelectionModalCancel = () => {
  //   this.setState({
  //     showSwitchSelectionModal: false,
  //   })
  // }

  // /**
  //  * Opens the SwitchSelectionNeededModal with a list of features
  //  * that have unconnected switch signals.
  //  * @param {Array} features - Array of features with unconnected signals
  //  *   Each feature should have: { partNumber: string, signals: string[] }
  //  */
  // openSwitchSelectionNeededModal = (features) => {
  //   this.setState({
  //     showSwitchSelectionNeededModal: true,
  //     featuresWithUnconnectedSignals: features,
  //   })
  // }

  resetSearch = () => {
    const { clearSearch } = this.props

    this.setState(
      {
        currentConflictingFeatures: null,
        currentConflictingSwitches: null,
        originalConflictingFeatures: null,
        selectedSearchFeatures: [],
        replacementConflictingFeatures: null,
        warning: null,
        canCommit: true,
        showCommitView: false,
        preSelectedSwitches: {},
        ioSwitches: [],
      },
      clearSearch
    )
  }

  toggleEditFeatures = () => {
    const {
      clearAllDropdowns,
      clearFilterTerms,
      clearSearchString,
      closeDrawer,
      resetDrawerWidth,
    } = this.props
    clearAllDropdowns()
    clearFilterTerms()
    clearSearchString()
    // have to reset drawer width because width is in navigator
    // open/close is in drawer - drawer width should be width drawer
    closeDrawer()
    resetDrawerWidth()
  }

  resetCurrentConflictState = () => {
    this.setState({
      currentConflictView: NO_CONFLICT,
      currentConflictingFeatures: null,
      originalConflictingFeatures: null,
      currentConflictModule: null,
      currentConflictPin: null,
      currentConflictingSwitches: null,
      currentConflictStep: 0,
      dirty: false,
    })
  }

  closeAndReset = () => {
    const { features } = this.props
    const { currentConflictView } = this.state

    if (CONFLICTS_TABLE_VIEWS[currentConflictView]) {
      this.setState({
        currentConflictView: CONFLICTS_OVER_VIEW,
        currentConflictSelection: null,
      })
    } else if (currentConflictView === CONFLICTS_OVER_VIEW) {
      this.resetCurrentConflictState()
    } else {
      this.setState(this.getInitialState(features))

      this.toggleEditFeatures()
    }
  }

  handleChangeSwitchSelection = (record) => {
    const { isMarkedForAddition } = record
    const { selectedSwitches, ioSwitches } = getIOSwitchList(record)

    if (isMarkedForAddition) {
      this.setState({
        showInputSwitchSelectionModal: true,
        isSwitchesMarkedForAddition: true,
        selectedSearchFeatures: [record],
        preSelectedSwitches: selectedSwitches,
        ioSwitches,
      })
    } else {
      this.setState({
        showFeatureInputModal: true,
        preSelectedSwitches: selectedSwitches,
        selectedSearchFeatures: [record],
        ioSwitches,
      })
    }
  }

  /**
   * Reopen switch mapping from the footer.
   *
   * This is the route out of a commit blocked by an outstanding mapping. The
   * staged-features table has no switch cell to click — AddRemoveFeaturesTable's
   * custom column is the remove checkbox, and its handleChangeSwitchSelection prop
   * is commented out at the destructure (predating this work), so nothing consumes
   * it. Without this action, dismissing the mapping modal was a dead end.
   *
   * Rebuilds the rows from the same derivation the gate uses, so the modal always
   * offers exactly what is blocking commit — the two cannot disagree.
   */
  handleReopenSwitchMapping = () => {
    const { proposedSet, preSelectedSwitches, addedSwitches } = this.state

    this.setState({
      ioSwitches: getOutstandingSwitchMappings(
        proposedSet,
        preSelectedSwitches,
        addedSwitches
      ),
      showFeatureInputModal: true,
    })
  }

  handleChangeConflictsView = (currentConflictView) => {
    if (currentConflictView === CONFLICTS_SWITCHES_WITH_SHARED_SIGNALS_VIEW) {
      this.setState({
        showFeatureInputModal: true,
        currentConflictView: CONFLICTS_OVER_VIEW,
      })
    } else {
      this.setState({
        currentConflictView,
      })
    }
  }

  handleCancelConflictsView = () => {
    this.setState({
      currentConflictingFeatures: null,
      originalConflictingFeatures: null,
      currentConflictingSwitches: null,
      currentConflictView: NO_CONFLICT,
    })
  }

  handleConfirmSelection = () => {
    const {
      currentConflictingFeatures,
      currentConflictView,
      currentConflictModule,
      currentConflictPin,
      currentConflictSelection,
      selectedSearchFeatures,
      proposedSet,
      addedSwitches,
      originalConflictingFeatures,
    } = this.state

    // Build an immutable updated state with the selection applied — matches the
    // pattern used by the hook-based flows and avoids mutating component state
    // directly (a React anti-pattern), which would also corrupt originalConflictingFeatures
    // since both state fields previously pointed at the same object.
    //
    // Use the original pin state (pre-pruning) when computing the rejection set.
    // If an option was removed from this pin by an earlier confirmation, the
    // current pin state no longer contains that option's features. Sourcing from
    // the original pin ensures those bystander features are included in
    // rejectedKeys and can cascade to other unresolved pins.
    const originalPin =
      originalConflictingFeatures?.[currentConflictView]?.[
        currentConflictModule
      ]?.[currentConflictPin]
    const sourcePin =
      originalPin && originalPin.selection === null
        ? originalPin
        : currentConflictingFeatures[currentConflictView][
            currentConflictModule
          ][currentConflictPin]
    const resolvedPin = {
      ...sourcePin,
      selection: currentConflictSelection,
    }
    const withSelection = {
      ...currentConflictingFeatures,
      [currentConflictView]: {
        ...currentConflictingFeatures[currentConflictView],
        [currentConflictModule]: {
          ...currentConflictingFeatures[currentConflictView][
            currentConflictModule
          ],
          [currentConflictPin]: resolvedPin,
        },
      },
    }

    // Propagate the rejection to other conflict types so that if the same
    // two features appear in both a DI and a DO conflict, resolving one
    // automatically resolves the other.
    const rejectedKeys = new Set(getRejectedFeatureKeys(resolvedPin))
    const propagated = pruneRejectedFeaturesFromConflicts(
      withSelection,
      rejectedKeys,
      originalConflictingFeatures
    )

    // need to rebuild ioSwitchesRequiringMapping on commit conflict resolve
    // get all features from conflict selection resolution that will be removed or
    // if a user choose not to resolve a conflict with a search result feature
    const featuresThatWillBeRemoved = getConflictingFeaturesThatWillBeRemoved(
      propagated,
      originalConflictingFeatures
    )

    const searchResultsFeatureMinusRemoved = selectedSearchFeatures.filter(
      (feature) =>
        !featuresThatWillBeRemoved.find(
          (removed) => feature.id === removed.featureId
        )
    )

    // remove any isMarkedForAddition staged if they are removed in conflict resolution
    const proposedSetMinusRemoved = proposedSet.filter(
      (feature) =>
        !featuresThatWillBeRemoved.find(
          (removed) =>
            feature.isMarkedForAddition && feature.id === removed.featureId
        )
    )

    // Enrich with vehicle data before evaluating switch mapping
    const vehiclePanelNumbers = getVehicleSwitchPanelNumbers(
      proposedSetMinusRemoved
    )
    const enrichedSearchResults = enrichIoSwitchesWithVehicleData(
      searchResultsFeatureMinusRemoved,
      vehiclePanelNumbers
    )

    const existingSignalIdsAfterRemoval = getSignalIdsOnVehicle(
      proposedSetMinusRemoved
    )
    // Recompute preSelectedSwitches so removed features' mappings are pruned —
    // but keep the ones that are still relevant. Rebuilding purely from the
    // current search selection dropped auto-assignments made for features staged
    // by an earlier add, which are still in proposedSetMinusRemoved.
    const existingSignalSwitchesAfterRemoval =
      getPreSelectedSwitchesForExistingSignals(
        enrichedSearchResults,
        existingSignalIdsAfterRemoval
      )
    const keptSignalIds = getAllSignalIds(proposedSetMinusRemoved)
    const priorPreSelectedStillValid = Object.entries(
      this.state.preSelectedSwitches || {}
    ).reduce(
      (acc, [signalId, panelNumber]) =>
        keptSignalIds.has(signalId) ? { ...acc, [signalId]: panelNumber } : acc,
      {}
    )
    const preSelectedSwitches = {
      ...priorPreSelectedStillValid,
      ...getSingleOptionIoSwitches(enrichedSearchResults),
      ...existingSignalSwitchesAfterRemoval,
    }

    // Derive the mapping rows from the whole staged set, not just this search
    // selection. Narrowing them here reintroduced "the gate blocks work the modal
    // does not offer": a feature staged by an earlier add whose mapping was
    // dismissed still counts towards the commit gate (which derives from
    // proposedSet), but its row disappeared from FeatureInputModal.
    const ioSwitchesRequiringSwitchMapping = getOutstandingSwitchMappings(
      proposedSetMinusRemoved,
      preSelectedSwitches,
      addedSwitches
    )

    // Count only unresolved pins — auto-resolved pins (selection !== null) are
    // filtered out in ConflictsResolveView and must not affect navigation.
    const modules = Object.values(propagated[currentConflictView])

    const unresolvedCount = modules.reduce(
      (acc, curr) =>
        acc + Object.values(curr).filter((p) => p.selection === null).length,
      0
    )

    const nextConflictView =
      unresolvedCount === 0 ? CONFLICTS_OVER_VIEW : currentConflictView
    // ConflictsResolveView filters to unresolved pins only, so the next
    // conflict is always at index 0.
    const nextStep = 0

    this.setState({
      currentConflictSelection: null,
      currentConflictingFeatures: propagated,
      currentConflictView: nextConflictView,
      currentConflictStep: nextStep,
      ioSwitches: ioSwitchesRequiringSwitchMapping,
      preSelectedSwitches,
      proposedSet: proposedSetMinusRemoved,
    })
  }

  handleOnSelect = (module, pin, view, selection, step) => {
    this.setState({
      currentConflictSelection: selection,
      currentConflictModule: module,
      currentConflictPin: pin,
      currentConflictView: view,
      dirty: true,
    })
  }

  handleReviewFeatures = () => {
    const { resetSearch } = this.props
    const {
      currentConflictingFeatures,
      selectedSearchFeatures,
      originalConflictingFeatures,
    } = this.state

    const reset = () => {
      this.setState(
        {
          currentConflictingFeatures: null,
          selectedSearchFeatures: [],
          currentConflictView: NO_CONFLICT,
        },
        resetSearch
      )
    }

    // if there are no conflicts but we are here, that means there were switches to map
    // if there were only switches to map, then just add selected search features
    if (!currentConflictingFeatures) {
      const { onGoingSet } = this.state
      const additions = selectedSearchFeatures.map(
        assoc('isMarkedForAddition', true)
      )
      const nextSet = [...additions, ...onGoingSet]

      this.setState(
        {
          onGoingSet: forceUnique(nextSet),
        },
        reset
      )
    }

    if (currentConflictingFeatures) {
      const removedSet = getConflictingFeaturesThatWillBeRemoved(
        currentConflictingFeatures,
        originalConflictingFeatures
      )
      const conflictingIds = map(prop('featureId'))(removedSet)

      this.handleToggleRemoveFeature(conflictingIds)
    }

    reset()
  }

  handleToggleFeatureCollectionModal = () => {
    const { serialNumber } = this.props
    window.open(
      `${
        process.env.PUBLIC_URL
      }/feature-collections?createFromVehicle=${encodeURIComponent(
        serialNumber
      )}`,
      '_blank',
      'noopener,noreferrer'
    )
  }

  handleKeepOrRemoveSwitchesModalCancel = () => {
    this.setState({
      isKeepOrRemoveSwitchesModalOpen: false,
      keepOrRemoveSwitches: [], // reset, this will trigger the modeal again or continue
    })
  }

  handleKeepOrRemoveSwitchesModalContinue = (selectedKeepOrRemoveSwitches) => {
    const { keepOrRemoveSwitches } = this.state

    const nextKeepOrRemoveSwitches = getUpdatedKeepOrRemoveSwitches(
      keepOrRemoveSwitches,
      selectedKeepOrRemoveSwitches
    )

    this.setState(
      {
        isKeepOrRemoveSwitchesModalOpen: false,
        keepOrRemoveSwitches: nextKeepOrRemoveSwitches,
      },
      () => this.commitUpdates()
    )
  }

  render() {
    const {
      serialNumber,
      modules,
      canRemoveAsBuiltFeature,
      authenticatedModuleNames,
      setModalViewForFeature,
      hasSearchResults,
      collectionNotification,
      clearCreateCollectionNotificaiton,
      vehicleArea,
      showFastFeatureFilters,
    } = this.props

    const {
      onGoingSet,
      selectedSearchFeatures,
      showCommitView,
      commitMessage,
      currentConflictingFeatures,
      currentConflictingSwitches,
      requestingValidation,
      dirty,
      isUpdating,
      isValidatingDynamicFeatures,
      showFeatureInputModal,
      showInputSwitchSelectionModal,
      // showSwitchSelectionNeededModal,
      // showSwitchSelectionModal,
      // featuresWithUnconnectedSignals,
      addedSwitches,
      addedIOSwitchesFromUpdate,
      removedIOSwitchesFromUpdate,
      isSwitchesMarkedForAddition,
      ioSwitches,
      proposedSet,
      preSelectedSwitches,
      currentConflictView,
      currentConflictSelection,
      currentConflictStep,
      showFeatureControlSolenoidAlert,
      optionalSolenoidsExceedingLimit,
      dynamicValidationData,
    } = this.state

    // Bug #505985: Use currentConflictView as the primary gate rather than
    // inspecting currentConflictingFeatures. This correctly handles both the
    // "switches to map" case (null conflicts but CONFLICTS_OVER_VIEW) and
    // avoids false positives from undefined/empty-keyed objects.
    const showConflictingFeatures = currentConflictView !== NO_CONFLICT
    const showConflictingSwitches =
      !isNull(currentConflictingSwitches) &&
      !isEmpty(currentConflictingSwitches) &&
      !showConflictingFeatures
    const showSearchAndFeatures =
      !showConflictingFeatures && !showConflictingSwitches
    const showConflictOverview = !!(
      (showConflictingFeatures || showConflictingSwitches) &&
      currentConflictView === CONFLICTS_OVER_VIEW
    )

    const disableAddFeature =
      !length(selectedSearchFeatures) ||
      requestingValidation ||
      (!hasSearchResults && length(selectedSearchFeatures) !== 0)

    const unresolvedConflictsCount = getUnresolvedConflictsCounts(
      currentConflictingFeatures
    )
    const unresolvedConflictsSum = unresolvedConflictsCount.reduce(
      (acc, curr) => acc + curr,
      0
    )

    const showConflictsOverView = currentConflictView === CONFLICTS_OVER_VIEW
    const showConflictsResolveView = Boolean(
      CONFLICTS_TABLE_VIEWS[currentConflictView]
    )

    const disableConfirmSelection = currentConflictSelection === null

    // Derived from the staged set and the assignments made so far, not from a
    // stored flag. This is the "switches with shared signals" count the conflict
    // overview shows, and the gate on the normal footer.
    //
    // It used to be `allSwitchesMapped ? 0 : length(ioSwitches)`. Both of those
    // are single values overwritten by whichever add happened last, so the count
    // went stale in every direction: completing a second feature's mapping
    // asserted the whole session was mapped, removing the feature that needed
    // mapping left the count stuck above zero, and reopening mapping from a
    // staged row replaced the list with just that row's signals.
    const outstandingSwitchMappings = getOutstandingSwitchMappings(
      proposedSet,
      preSelectedSwitches,
      addedSwitches
    )
    const numSwitchConflicts = outstandingSwitchMappings.length

    // Bug #505985: switch mapping now opens as a modal straight from the
    // no-conflict state, so it no longer passes through the CONFLICTS_OVER_VIEW
    // gate that used to block "Review Features" via allConflictsResolved.
    // Dismissing the mapping modal leaves the feature staged with unassigned
    // signals, so the normal footer needs its own block.
    const hasUnmappedSwitches = numSwitchConflicts > 0

    // Metadata for every feature the mapping rows reference. `ioSwitches` can span
    // several adds, while selectedSearchFeatures only holds the latest selection —
    // handing that to the modals means FeatureInputSwitchSelectionModal throws on
    // the row it has no feature for, and FeatureInputModal quietly omits it. The
    // staged set is consulted first because its copies are authoritative.
    const mappingFeatures = getFeaturesForMappingRows(
      ioSwitches,
      proposedSet,
      selectedSearchFeatures
    )

    const allConflictsResolved =
      unresolvedConflictsSum === 0 && numSwitchConflicts === 0

    const maxLogicsMessage = getMaxNotificationString(
      LOGIC_SETS,
      onGoingSet,
      this.props.moduleCapacities
    )
    const maxTimersMessage = getMaxNotificationString(
      TIMERS,
      onGoingSet,
      this.props.moduleCapacities
    )
    const maxCanInputsMessage = getMaxNotificationString(
      CAN_INPUTS,
      !isNull(onGoingSet)
        ? onGoingSet.filter((item) => !item.isMarkedForDeletion)
        : []
    )
    const maxSwitchIndicatorsMessage = getMaxNotificationString(
      SWITCH_INDICATORS,
      !isNull(onGoingSet)
        ? onGoingSet.filter((item) => !item.isMarkedForDeletion)
        : []
    )

    const isOverResourceLimits =
      Boolean(maxLogicsMessage) ||
      Boolean(maxTimersMessage) ||
      Boolean(maxCanInputsMessage) ||
      Boolean(maxSwitchIndicatorsMessage)

    if (!this.props.features || isNull(onGoingSet)) return <Loading />

    return (
      <>
        <Alert
          type="info"
          persistent
          closable={false}
          actionTrigger={{
            onClick: this.toggleEditFeatures,
            text: strings.vehicle_banner_exit,
          }}
          message={`${strings.add_or_remove_features_to_vehicle} ${serialNumber}`}
        />
        {showConflictingFeatures && (
          <>
            {showConflictsOverView && (
              <ConflictsOverView
                unresolvedConflictsCount={unresolvedConflictsCount}
                changeView={this.handleChangeConflictsView}
                handleCancel={this.handleCancelConflictsView}
                numSwitchConflicts={numSwitchConflicts}
              />
            )}
            {showConflictsResolveView && (
              <ConflictsResolveView
                conflicts={currentConflictingFeatures}
                view={currentConflictView}
                allFeatures={onGoingSet}
                onSelect={this.handleOnSelect}
                currentConflictSelection={currentConflictSelection}
                currentConflictStep={currentConflictStep}
              />
            )}
          </>
        )}
        {!showConflictingFeatures && (
          <StyledHeader>{`${strings.editing_vehicle}: ${serialNumber}`}</StyledHeader>
        )}
        {!showCommitView && !showConflictingFeatures && (
          <ArticleStyled>
            {showConflictingSwitches && (
              <>
                <Row>
                  <Col span={24}>
                    <Header type="h3">
                      {strings.add_features_to} {serialNumber}
                    </Header>
                    <ConflictingSwitches
                      currentConflictingSwitches={currentConflictingSwitches}
                    />
                  </Col>
                </Row>
              </>
            )}
            {Boolean(collectionNotification) && (
              <>
                <Alert
                  type={prop('type', collectionNotification)}
                  closable
                  message={
                    propEq('type', 'success', collectionNotification)
                      ? strings.create_collection_success(
                          prop('title', collectionNotification)
                        )
                      : prop('errorMessage', collectionNotification)
                  }
                  onClose={clearCreateCollectionNotificaiton}
                />
                <br />
              </>
            )}
            {showSearchAndFeatures && (
              <>
                {[
                  {
                    showWarning: Boolean(maxLogicsMessage),
                    message: maxLogicsMessage,
                  },
                  {
                    showWarning: Boolean(maxTimersMessage),
                    message: maxTimersMessage,
                  },
                  {
                    showWarning: Boolean(maxCanInputsMessage),
                    message: maxCanInputsMessage,
                  },
                  {
                    showWarning: Boolean(maxSwitchIndicatorsMessage),
                    message: maxSwitchIndicatorsMessage,
                  },
                ]
                  .filter((item) => item.showWarning)
                  .map((item, index) => (
                    <>
                      <Alert
                        type="warning"
                        persistent
                        closable={false}
                        message={item.message}
                      />
                      <br />
                    </>
                  ))}
                <Row>
                  <Col span={24}>
                    {vehicleArea !== 'ecus' &&
                      vehicleArea !== 'switchandgauge' && (
                        <>
                          {showFeatureControlSolenoidAlert && (
                            <>
                              <Alert
                                type="info"
                                persistent
                                closable={false}
                                message={strings.feature_control_solenoids_notification(
                                  serialNumber
                                )}
                              />
                              <br />
                            </>
                          )}
                          {optionalSolenoidsExceedingLimit?.length > 0 && (
                            <>
                              <Alert
                                type="info"
                                persistent
                                closable={false}
                                message={
                                  strings.optional_solenoids_exceeding_limits
                                }
                              />
                              <br />
                            </>
                          )}
                        </>
                      )}
                    <FeatureCollectionToggle
                      serialNumber={serialNumber}
                      hideFeatureCollectionToggle={[
                        'ecus',
                        'switchandgauge',
                      ].includes(vehicleArea)}
                      hideFastFeatureToggle={FAST_FEATURES_EXCLUDED_SUBTYPES.includes(
                        this.props.vehicleSubType
                      )}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <AddRemoveFeatureSearchAndResultsTable
                      features={onGoingSet}
                      onSelected={this.handleSelectedFeature}
                      onSelectedRevision={this.handleSelectedFeatureRevision}
                      onSelectAll={this.handleSelectAllFeatures}
                      selected={selectedSearchFeatures}
                      modules={modules}
                      serialNumber={serialNumber}
                      authenticatedModuleNames={authenticatedModuleNames}
                      setModalViewForFeature={setModalViewForFeature}
                      showFastFeatureFilters={showFastFeatureFilters}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    {requestingValidation ? (
                      <Loading contained size="sm" />
                    ) : (
                      <>
                        <Header type="h2">
                          {strings.features_serial(serialNumber)}
                        </Header>
                        <AddRemoveFeaturesTable
                          isEditable
                          onCustomColClick={this.handleToggleRemoveFeature}
                          features={onGoingSet}
                          vehicleSubType={this.props.vehicleSubType}
                          onAddFeature={this.handleAddFeature}
                          canRemoveAsBuiltFeature={canRemoveAsBuiltFeature}
                          authenticatedModuleNames={authenticatedModuleNames}
                          vehicleECUs={this.props.vehicleECUs}
                          handleChangeSwitchSelection={
                            this.handleChangeSwitchSelection
                          }
                          serialNumber={serialNumber}
                          headerAction={
                            this.props.canViewRevision &&
                            onGoingSet &&
                            !showFastFeatureFilters
                              ? (sectionType) => {
                                  const sectionFeatures =
                                    sectionType === 'factory'
                                      ? onGoingSet.filter((f) =>
                                          restrictedModules.includes(
                                            f.moduleName
                                          )
                                        )
                                      : onGoingSet.filter(
                                          (f) =>
                                            !restrictedModules.includes(
                                              f.moduleName
                                            )
                                        )
                                  const hasUpdates = sectionFeatures.some(
                                    (f) =>
                                      !f.isMarkedForDeletion &&
                                      (getUpdatedFeature(
                                        f,
                                        this.props.vehicleECUs,
                                        onGoingSet
                                      ) !== null ||
                                        (f.status &&
                                          f.status.toLowerCase() ===
                                            'obsolete'))
                                  )
                                  return (
                                    <Button
                                      type="secondary"
                                      disabled={!hasUpdates}
                                      onClick={() =>
                                        this.setState({
                                          showFeatureVersionUpdateModal: true,
                                          featureUpdateSection: sectionType,
                                        })
                                      }
                                      iconProps={{
                                        icon: 'refresh',
                                        size: 14,
                                        fill: hasUpdates
                                          ? 'bluePrimary'
                                          : 'slateDisabled',
                                      }}
                                      style={{
                                        whiteSpace: 'nowrap',
                                        flexShrink: 0,
                                        padding: '8px',
                                        height: 'auto',
                                        fontSize: '14px',
                                        margin: '0px',
                                      }}
                                    >
                                      {strings.update_feature_versions}
                                    </Button>
                                  )
                                }
                              : null
                          }
                        />
                      </>
                    )}
                  </Col>
                </Row>
              </>
            )}
          </ArticleStyled>
        )}
        {this.state.isKeepOrRemoveSwitchesModalOpen && (
          <KeepOrRemoveSwitches
            isOpen={this.state.isKeepOrRemoveSwitchesModalOpen}
            onClickCancel={this.handleKeepOrRemoveSwitchesModalCancel}
            onClickContinue={this.handleKeepOrRemoveSwitchesModalContinue}
            removedSwitches={this.state.keepOrRemoveSwitches}
            onGoingSet={this.state.onGoingSet}
            serialNumber={serialNumber}
          />
        )}
        {showCommitView && (
          <CommitView
            updated={onGoingSet.filter(prop('isMarkedForUpdate'))}
            added={onGoingSet.filter(
              both(prop('isMarkedForAddition'), notProp('isMarkedForUpdate'))
            )}
            showNewSolenoidsList={showFeatureControlSolenoidAlert}
            removed={onGoingSet.filter(prop('isMarkedForDeletion'))}
            mappedIoSwitches={{
              ...addedSwitches,
              ...this.state.preSelectedSwitches,
            }}
            addedIOSwitchesFromUpdate={addedIOSwitchesFromUpdate}
            removedIOSwitchesFromUpdate={removedIOSwitchesFromUpdate}
            commitMessage={commitMessage}
            onCommitMessageChange={this.handleCommitMessageChange}
            keepOrRemoveSwitches={this.state.keepOrRemoveSwitches}
            serialNumber={serialNumber}
          />
        )}

        {showFeatureInputModal && (
          <FeatureInputModal
            isOpen={showFeatureInputModal}
            featureInput={ioSwitches}
            serialNumber={serialNumber}
            onClickCancel={() =>
              this.setState({ showFeatureInputModal: false })
            }
            onClickSelect={this.handleSelectSwitch}
            selectedSearchFeatures={mappingFeatures}
          />
        )}

        {showInputSwitchSelectionModal && (
          <FeatureInputSwitchSelectionModal
            selectedSearchFeatures={mappingFeatures}
            isOpen={showInputSwitchSelectionModal}
            featureInput={ioSwitches}
            partNumber={selectedSearchFeatures.partNumber}
            serialNumber={serialNumber}
            isSwitchesMarkedForAddition={isSwitchesMarkedForAddition}
            onClickCancel={() =>
              this.setState({ showInputSwitchSelectionModal: false })
            }
            addedSwitches={addedSwitches}
            onClickSelect={this.handleSelectInputSwitch}
          />
        )}

        {/* {showSwitchSelectionNeededModal && (
          <SwitchSelectionNeededModal
            isOpen={showSwitchSelectionNeededModal}
            onCancel={this.handleCloseSwitchSelectionNeededModal}
            onSelectSwitches={this.handleSelectSwitchesFromNeededModal}
            featuresWithUnconnectedSignals={featuresWithUnconnectedSignals}
          />
        )}

        {showSwitchSelectionModal && (
          <SwitchSelectionModal
            isOpen={showSwitchSelectionModal}
            onCancel={this.handleSwitchSelectionModalCancel}
            onConfirm={this.handleSwitchSelectionModalConfirm}
            serialNumber={serialNumber}
            featureInput={featuresWithUnconnectedSignals}
            selectedSearchFeatures={selectedSearchFeatures}
            initialSelectedSwitches={addedSwitches}
            isSwitchesMarkedForAddition={isSwitchesMarkedForAddition}
          />
        )} */}

        <FooterStyled>
          <Row>
            <Col span={24}>
              <ChecPopconfirm
                showConfirm={dirty && !showConflictsResolveView}
                title={strings.confirm_cancel_feature_edit}
                okText={strings.cancel_updates}
                okType="danger"
                cancelType="primary"
                cancelText={strings.continue_updates}
                onConfirm={this.closeAndReset}
                placement="topLeft"
              >
                <Button
                  onClick={() => this.props.resetSearch()}
                  type="secondary"
                >
                  {strings.cancel}
                </Button>
              </ChecPopconfirm>
              <ActionButtons
                showCommitView={showCommitView}
                disableAddFeature={disableAddFeature}
                disableConfirmSelection={disableConfirmSelection}
                showConflictingFeaturesBtns={showConflictingFeatures}
                showConflictingSwitchesBtns={showConflictingSwitches}
                showCreateFeatureCollBtn={
                  vehicleArea !== 'ecus' && vehicleArea !== 'switchandgauge'
                }
                dirty={dirty}
                commitMessage={commitMessage}
                handleConfirmSelection={this.handleConfirmSelection}
                handleContinueAndAddSwitch={this.handleContinueAndAddSwitch}
                handleCommitUpdates={this.handleCommitUpdates}
                handleAddFeature={this.handleAddFeature}
                isUpdating={isUpdating}
                isValidatingDynamicFeatures={isValidatingDynamicFeatures}
                showConflictOverviewBtns={showConflictOverview}
                allConflictsResolved={allConflictsResolved}
                hasUnmappedSwitches={hasUnmappedSwitches}
                handleReopenSwitchMapping={this.handleReopenSwitchMapping}
                handleReviewFeatures={this.handleReviewFeatures}
                handleToggleFeatureCollectionModal={
                  this.handleToggleFeatureCollectionModal
                }
                isOverResourceLimits={isOverResourceLimits}
                isValidating={this.state.requestingValidation}
              />
            </Col>
          </Row>
        </FooterStyled>

        <DynamicFeatureValidationModal
          data={dynamicValidationData}
          serialNumber={serialNumber}
          onClose={() => {
            this.setState({
              dynamicValidationData: [],
            })
          }}
        />

        {this.state.showFeatureVersionUpdateModal && (
          <FeatureVersionUpdateModal
            visible
            features={
              onGoingSet
                ? onGoingSet.filter(
                    (f) =>
                      ((f.isFeatureLatestRevision === false &&
                        f.revisions &&
                        f.revisions.length > 0) ||
                        (f.latestOnVehicle === false &&
                          f.latestSnapshot?.object?.feature) ||
                        (f.status && f.status.toLowerCase() === 'obsolete')) &&
                      !f.isMarkedForDeletion &&
                      (this.state.featureUpdateSection === 'factory'
                        ? restrictedModules.includes(f.moduleName)
                        : !restrictedModules.includes(f.moduleName))
                  )
                : []
            }
            serialNumber={serialNumber}
            vehicleECUs={this.props.vehicleECUs}
            onGoingSet={onGoingSet}
            onClose={() =>
              this.setState({
                showFeatureVersionUpdateModal: false,
                featureUpdateSection: null,
              })
            }
            onCommit={async (selections) => {
              this.setState({
                showFeatureVersionUpdateModal: false,
                featureUpdateSection: null,
              })
              if (!selections || selections.length === 0) return

              // Only process features the user chose to update
              const validSelections = selections.filter(
                ({ updatedFeature, selection }) =>
                  selection === 'update' && !!updatedFeature
              )
              if (validSelections.length === 0) return

              const { serialNumber } = this.props
              const {
                proposedSet,
                addedIOSwitchesFromUpdate,
                removedIOSwitchesFromUpdate,
              } = this.state

              // Build a map of feature id -> enriched item with merged data
              const enrichedMap = new Map()
              validSelections.forEach(({ currentFeature, updatedFeature }) => {
                const mergedFeature = {
                  ...currentFeature,
                  ...updatedFeature,
                }
                enrichedMap.set(currentFeature.id, {
                  ...currentFeature,
                  latestOnVehicle: false,
                  latestSnapshot: { object: { feature: mergedFeature } },
                })
              })

              // Apply all updates to the proposedSet in one pass
              // (equivalent to running markedForUpdateSet for each item)
              const updatedSet = proposedSet.map((f) => {
                const enriched = enrichedMap.get(f.id)
                if (!enriched) return f
                return {
                  ...enriched.latestSnapshot.object.feature,
                  uri: enriched.uri,
                  revision:
                    enriched.latestSnapshot?.object?.feature?.revision ||
                    enriched.revision,
                  isMarkedForAddition: true,
                  isMarkedForUpdate: true,
                  isFeatureLatestRevision: true,
                  latestOnVehicle: true,
                  previousSnapshot: enriched,
                }
              })

              // Single validation call for all updates
              this.setState({ requestingValidation: true })

              const { currentConflictingFeatures, err } =
                await validateAndGetConflicts(
                  this.props.dispatch,
                  serialNumber,
                  updatedSet
                )

              if (err) {
                this.props.apiErrorHandler()
                return
              }

              this.setState({ requestingValidation: false })

              // Accumulate switch diffs from all updated features
              let allAddedSwitches = { ...addedIOSwitchesFromUpdate }
              let allRemovedSwitches = { ...removedIOSwitchesFromUpdate }
              validSelections.forEach(({ currentFeature }) => {
                const enriched = enrichedMap.get(currentFeature.id)
                if (enriched) {
                  const { addedSwitches, removedSwitches } =
                    getSwitchDiffOnUpdate(enriched)
                  allAddedSwitches = { ...allAddedSwitches, ...addedSwitches }
                  allRemovedSwitches = {
                    ...allRemovedSwitches,
                    ...removedSwitches,
                  }
                }
              })

              // validateAndGetConflicts returns { currentConflictingFeatures: false }
              // for the no-conflicts case. isEmptyOrNil(false) is false in Ramda
              // (false is neither nil nor an empty collection), so the plain
              // isEmptyOrNil check would always route to the else branch and leave
              // onGoingSet untouched. Treat false explicitly as "no conflicts".
              const noConflicts =
                currentConflictingFeatures === false ||
                isEmptyOrNil(currentConflictingFeatures)
              const dirty = updatedSet.some(
                (f) =>
                  f.isMarkedForAddition ||
                  f.isMarkedForDeletion ||
                  f.isMarkedForUpdate
              )

              if (noConflicts) {
                this.setState(
                  {
                    onGoingSet: forceUnique(clone(updatedSet)),
                    proposedSet: forceUnique(updatedSet),
                    addedIOSwitchesFromUpdate: allAddedSwitches,
                    removedIOSwitchesFromUpdate: allRemovedSwitches,
                    dirty,
                  },
                  this.props.resetSearch
                )
              } else {
                this.setState({
                  proposedSet: updatedSet,
                  currentConflictingFeatures,
                  originalConflictingFeatures: clone(
                    currentConflictingFeatures
                  ),
                  addedIOSwitchesFromUpdate: allAddedSwitches,
                  removedIOSwitchesFromUpdate: allRemovedSwitches,
                  dirty,
                })
              }
            }}
          />
        )}
      </>
    )
  }
}

AddRemoveVehicleFeatures.propTypes = {
  dispatch: PropTypes.func.isRequired,
  serialNumber: PropTypes.string,
  vehicleArea: PropTypes.string,
  features: PropTypes.array.isRequired,
  controlledOuputConflict: PropTypes.array,
  configuredInputConflict: PropTypes.array,
  clearSearch: PropTypes.func,
  truckFeaturesUpdated: PropTypes.func,
  featureUpdateCompleteByVehicleArea: PropTypes.func,
  createSystemNotification: PropTypes.func,
  modules: PropTypes.array,
  moduleCapacities: PropTypes.array,
  canRemoveAsBuiltFeature: PropTypes.bool,
  authenticatedModuleNames: PropTypes.array,
  setModalViewForFeature: PropTypes.func,
  clearAllDropdowns: PropTypes.func,
  clearFilterTerms: PropTypes.func,
  clearSearchString: PropTypes.func,
  closeDrawer: PropTypes.func,
  resetSearch: PropTypes.func,
  hasSearchResults: PropTypes.bool,
  apiErrorHandler: PropTypes.func,
  history: PropTypes.func,
  collectionNotification: PropTypes.string,
  clearCreateCollectionNotificaiton: PropTypes.func,
  resetDrawerWidth: PropTypes.func,
  vehicleSubType: PropTypes.string,
  vehicleECUs: PropTypes.array,
  solenoidsOnVehicle: PropTypes.array,
  availableSlotsOnVehicle: PropTypes.array,
  goToPneumatics: PropTypes.func,
  showFastFeatureFilters: PropTypes.bool,
  canViewRevision: PropTypes.bool,
}

export default AddRemoveVehicleFeatures
